import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export const WarningImageSection = () => {
  return <section className="py-20 bg-[#050505] relative overflow-hidden" data-id="element-3240">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,20,20,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(20,20,20,0.5)_1px,transparent_1px)] bg-[size:40px_40px] opacity-30 pointer-events-none" data-id="element-3241" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-3242">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-3243">
          {/* Forensic Frame */}
          <div className="relative p-2 border border-[#FF0000]/30 bg-[#0a0a0a]" data-id="element-3244">
            {/* Corner Markers */}
            <div className="absolute -top-1 -left-1 w-6 h-6 border-t-2 border-l-2 border-[#FF0000] z-20" data-id="element-3245" />
            <div className="absolute -top-1 -right-1 w-6 h-6 border-t-2 border-r-2 border-[#FF0000] z-20" data-id="element-3246" />
            <div className="absolute -bottom-1 -left-1 w-6 h-6 border-b-2 border-l-2 border-[#FF0000] z-20" data-id="element-3247" />
            <div className="absolute -bottom-1 -right-1 w-6 h-6 border-b-2 border-r-2 border-[#FF0000] z-20" data-id="element-3248" />

            <div className="relative overflow-hidden rounded-lg" data-id="element-3249">
              <img src="https://cdn.magicpatterns.com/uploads/xsZMS2rh9Tpof42GsoB2Lg/file_000000002864720aa5f3e466fc426e65.png" alt="Red warning flag on metallic surface with dramatic lighting and energy trails - symbolic representation of relationship red flags and danger signals" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-700" loading="lazy" decoding="async" data-id="element-3250" />

              {/* Pulsing Alert Indicator */}
              <div className="absolute top-4 left-4 flex items-center gap-2 bg-black/70 border border-[#FF0000]/50 px-3 py-1" data-id="element-3251">
                <span className="w-2 h-2 bg-[#FF0000] rounded-full animate-pulse" data-id="element-3252" />
                <span className="text-[#FF0000] text-xs font-mono tracking-wider uppercase" data-id="element-3253">
                  Warning Detected
                </span>
              </div>
            </div>
          </div>

          {/* Glow Effect */}
          <div className="absolute -inset-4 bg-[#FF0000]/5 blur-3xl -z-10 rounded-full" data-id="element-3254" />
        </motion.div>
      </div>
    </section>;
};